// Core
import React, { MouseEventHandler } from 'react';

export enum ModalSize {
  sm = 'sm',
  lg = 'lg',
  xl = 'xl',
}

export type ModalWidth = '40%' | '85%' | '98%';
export type ModalHeight = 'auto' | '96%';

export interface ModalPanelProps {
  children: React.ReactNode;
  className?: string;
  customHeader?: React.ReactNode;
  description?: string;
  getContainer?: () => HTMLElement;
  onBack?: MouseEventHandler<HTMLElement> | false;
  onClose: () => void;
  showModal: boolean;
  size?: ModalSize;
  testId?: string;
  title?: string;
}
